// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2sBxy","boxTitle":"Qualiphy_boxTitle__I5Sgo","box":"Qualiphy_box__6pI1L","toggleWrap":"Qualiphy_toggleWrap__3srhu"};